import { formatDate } from "features/helpers/utils";
import moment from "moment";
import React, { createContext, useEffect, useState } from "react";

export const KeyMatrixContext = createContext();

export default function KeyMatrixProvider({ children }) {
  const [granularity, setGranularity] = useState("daily"); // daily, weekly, monthly
  const [range, setRange] = useState("7d");
  const [isLoading, setIsLoading] = useState({
    matrixStats: false,
    walletAnalysisChart: false,
    userMatrixChart: false,
    cohortChart: false,
    objectivesBreakdownChart: false,
  });

  const granularityRanges = {
    daily: ["7d", "14d", "30d"],
    weekly: ["4w", "8w", "12w"],
    monthly: ["3m", "6m", "12m"],
  };

  function setGranularityRange(granularity) {
    setGranularity(granularity);
    setRange(granularityRanges[granularity][0]);
  }
  const formatLabel = (time) => {
    const today = moment().endOf("day"); // 今天的結束時間

    if (granularity === "daily") {
      return formatDate(time); // 單日直接回傳格式化日期
    }

    if (granularity === "weekly") {
      const endOfWeek = moment(time).add(1, "weeks").endOf("day");
      const adjustedEnd = moment.min(endOfWeek, today); // 取結束日期和今天的最小值
      return `${formatDate(time)} - ${formatDate(adjustedEnd)}`;
    }

    if (granularity === "monthly") {
      const endOfMonth = moment(time).add(1, "months");
      const adjustedEnd = moment.min(endOfMonth, today); // 取結束日期和今天的最小值
      return `${formatDate(time)} - ${formatDate(adjustedEnd)}`;
    }
  };

  return (
    <KeyMatrixContext.Provider
      value={{
        granularity,
        setGranularityRange,
        range,
        setRange,
        rangeOptions: granularityRanges[granularity],
        formatLabel,
        isLoading,
        setIsLoading,
      }}
    >
      {children}
    </KeyMatrixContext.Provider>
  );
}
